var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPriceTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    d: "M463.315,10.189l-169.253-0.094c-10.626-0.006-20.818,4.213-28.332,11.726L21.726,265.825  c-15.635,15.635-15.635,40.984,0,56.619l167.812,167.812c15.635,15.635,40.984,15.635,56.619,0L490.18,246.234  c7.503-7.503,11.72-17.677,11.726-28.287L502,48.917L463.315,10.189z",
    fill: "#f71a1a",
    "data-original": "#fed79a"
  }), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {},
    cx: 410.28,
    cy: 101.709,
    r: 30.965,
    fill: "#ffffff",
    "data-original": "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M420.088,208.434l-116.54-116.54c-11.557-11.557-30.295-11.557-41.852,0L77.274,276.316   c-11.557,11.557-11.557,30.295,0,41.852l116.54,116.54c11.557,11.557,30.295,11.557,41.852,0l184.422-184.422   C431.645,238.729,431.645,219.991,420.088,208.434z",
    fill: "#ffffff",
    "data-original": "#ffffff"
  })), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M154.88,142.67c2.63,0,5.21-1.07,7.07-2.93c1.859-1.86,2.93-4.44,2.93-7.07s-1.07-5.21-2.93-7.07  c-1.86-1.86-4.44-2.93-7.07-2.93s-5.21,1.07-7.07,2.93c-1.859,1.86-2.93,4.44-2.93,7.07s1.07,5.21,2.93,7.07  C149.67,141.601,152.25,142.67,154.88,142.67z",
    fill: "#000000",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M496.71,29.471l12.361-12.361c3.905-3.905,3.905-10.237,0-14.143c-3.906-3.905-10.236-3.905-14.143,0L482.574,15.32  L470.391,3.122c-1.875-1.876-4.417-2.932-7.069-2.933L294.068,0.095c-0.01,0-0.019,0-0.028,0c-13.365,0-25.93,5.204-35.381,14.655  l-84.46,84.46c-3.905,3.905-3.905,10.237,0,14.143c3.906,3.905,10.236,3.905,14.143,0l84.46-84.46  c5.674-5.674,13.215-8.797,21.238-8.797c0.006,0,0.012,0,0.017,0l165.111,0.092l9.266,9.276L431.33,66.568  c-15.734-9.424-36.477-7.369-50.021,6.173c-7.737,7.738-11.998,18.025-11.998,28.967s4.261,21.229,11.998,28.967  c7.986,7.986,18.477,11.979,28.968,11.979c10.49,0,20.98-3.993,28.967-11.979l0,0c13.522-13.523,15.591-34.225,6.216-49.951  l37.109-37.109l9.43,9.441l-0.092,164.887c-0.005,8.016-3.129,15.553-8.798,21.222L239.086,483.186  c-5.673,5.673-13.216,8.797-21.238,8.797s-15.565-3.124-21.238-8.797L28.798,315.373C23.124,309.7,20,302.157,20,294.135  s3.124-15.565,8.798-21.238l107.794-107.794c3.905-3.905,3.905-10.237,0-14.143c-3.906-3.905-10.236-3.905-14.143,0L14.655,258.754  C5.205,268.204,0,280.77,0,294.135s5.205,25.931,14.655,35.381l167.812,167.813c9.755,9.754,22.567,14.632,35.381,14.632  s25.626-4.878,35.381-14.632l244.022-244.023c9.443-9.443,14.647-21.999,14.655-35.354L512,48.922  c0.002-2.652-1.051-5.196-2.925-7.072L496.71,29.471z M425.101,116.531c-3.96,3.96-9.225,6.141-14.824,6.141  c-5.601,0-10.865-2.181-14.825-6.141c-8.175-8.174-8.175-21.475,0-29.649c4.088-4.088,9.455-6.131,14.825-6.131  c2.022,0,4.043,0.291,5.997,0.871l-11.542,11.542c-3.905,3.905-3.905,10.237,0,14.143c1.953,1.953,4.512,2.929,7.071,2.929  s5.118-0.976,7.071-2.929l11.51-11.51C432.463,102.916,430.704,110.928,425.101,116.531z",
    fill: "#000000",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M58.606,297.242c0,10.576,4.118,20.52,11.597,27.998l116.54,116.538c7.479,7.479,17.421,11.598,27.997,11.598  s20.52-4.118,27.997-11.597l184.422-184.422c7.479-7.479,11.597-17.421,11.597-27.997c0-10.576-4.118-20.519-11.597-27.997  L310.62,84.823c-15.438-15.438-40.559-15.436-55.995,0L70.204,269.245C62.725,276.723,58.606,286.666,58.606,297.242z   M84.346,283.388L268.768,98.966c3.82-3.82,8.837-5.73,13.855-5.73c5.017,0,10.035,1.911,13.854,5.73l116.539,116.539l0,0  c3.701,3.701,5.739,8.621,5.739,13.855c0,5.233-2.038,10.154-5.739,13.854L228.595,427.638c-3.7,3.7-8.621,5.738-13.854,5.738  s-10.154-2.038-13.854-5.739L84.346,311.098c-3.701-3.701-5.739-8.621-5.739-13.855C78.606,292.009,80.645,287.088,84.346,283.388z",
    fill: "#000000",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M215.277,306.742c2.56,0,5.118-0.977,7.071-2.929l6.836-6.836c6.718,4.149,14.264,6.251,21.676,6.251  c9.549-0.001,18.872-3.474,25.893-10.494c14.736-14.737,13.84-39.612-1.995-55.457c-0.003-0.003-0.005-0.006-0.008-0.009  c-4.026-4.026-6.386-9.171-6.644-14.49c-0.239-4.952,1.408-9.459,4.641-12.691c6.94-6.941,19.132-6.043,27.179,2  c0.001,0.001,0.001,0.002,0.002,0.003s0.002,0.001,0.002,0.001c8.044,8.047,8.941,20.239,2,27.18  c-3.905,3.905-3.905,10.237,0,14.143c1.953,1.953,4.512,2.929,7.071,2.929s5.118-0.976,7.071-2.929  c12.47-12.471,13.745-32.199,4.248-47.574l5.758-5.758c3.905-3.905,3.905-10.237,0-14.143c-3.906-3.905-10.236-3.905-14.143,0  l-5.758,5.758c-15.375-9.497-35.103-8.222-47.574,4.247c-7.271,7.271-10.991,17.145-10.475,27.802  c0.499,10.292,4.931,20.117,12.478,27.664c0.001,0.001,0.002,0.001,0.002,0.002c8.043,8.047,8.941,20.239,2.001,27.179  c-6.943,6.941-19.137,6.042-27.183-2.002c-8.046-8.047-8.944-20.241-2.003-27.183c3.905-3.905,3.905-10.237,0-14.143  c-3.906-3.905-10.236-3.905-14.143,0c-12.47,12.47-13.744,32.198-4.247,47.574l-6.832,6.831c-3.905,3.905-3.905,10.237,0,14.143  C210.159,305.766,212.718,306.742,215.277,306.742z",
    fill: "#000000",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M210.725,380.01c1.953,1.952,4.512,2.929,7.071,2.929s5.118-0.977,7.071-2.929c3.905-3.905,3.905-10.237,0-14.143  l-51.361-51.362c-3.905-3.902-10.235-3.904-14.143,0c-3.905,3.905-3.905,10.237,0,14.143L210.725,380.01z",
    fill: "#000000",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M139.04,304.19c2.64,0,5.21-1.07,7.069-2.93c1.87-1.87,2.94-4.44,2.94-7.07c0-2.64-1.07-5.21-2.94-7.08  c-1.859-1.859-4.43-2.93-7.069-2.93c-2.63,0-5.2,1.07-7.07,2.93c-1.86,1.86-2.93,4.44-2.93,7.08c0,2.63,1.069,5.21,2.93,7.07  C133.83,303.12,136.41,304.19,139.04,304.19z",
    fill: "#000000",
    "data-original": "#000000",
    style: {}
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceTag);
export default __webpack_public_path__ + "static/media/price-tag.af530c6c93780c94a775eae4e16f29ca.svg";
export { ForwardRef as ReactComponent };